import React, { createContext, useContext } from 'react';
import { useOdooWebSocket } from '../hooks/useOdooWebSocket';

const OdooSocketContext = createContext();

export const OdooSocketProvider = ({ children }) => {
  const { ws, messages, status } = useOdooWebSocket({ channels: ['in_progress'] });

  return (
    <OdooSocketContext.Provider value={{ ws, messages, status }}>
      {children}
    </OdooSocketContext.Provider>
  );
};

export const useOdooSocket = () => useContext(OdooSocketContext);
